(function () {
  "use strict";

  function initKeuzehulp(container) {
    const treeId = container.dataset.treeId;
    const shop = container.dataset.shop;
    const appUrl = container.dataset.appUrl;
    const lang = container.dataset.lang || "nl";
    const config = {
      primaryColor: container.dataset.primaryColor || "#3b82f6",
      buttonTextColor: container.dataset.buttonTextColor || container.dataset.primaryColor || "#3b82f6",
      answerBorderColor: container.dataset.answerBorderColor || container.dataset.primaryColor || "#3b82f6",
      answerTextColor: container.dataset.answerTextColor || container.dataset.primaryColor || "#3b82f6",
      ctaColor: container.dataset.ctaColor || container.dataset.primaryColor || "#3b82f6",
      ctaTextColor: container.dataset.ctaTextColor || "#ffffff",
      resultLabelText: container.dataset.resultLabelText || (lang === "en" ? "Our recommendation" : "Onze aanbeveling"),
      ctaText: container.dataset.ctaText || (lang === "en" ? "View product" : "Bekijk product"),
      imageRatio: container.dataset.imageRatio || "1/1",
      imageSize: parseInt(container.dataset.imageSize || "160", 10),
      resultLabelColor: container.dataset.resultLabelColor || container.dataset.primaryColor || "#10b981",
      extraLinkUrl: container.dataset.extraLinkUrl || "",
      extraLinkText: container.dataset.extraLinkText || "",
      extraLinkColor: container.dataset.extraLinkColor || "#6b7280",
      answerFontSize: container.dataset.answerFontSize || "14",
      hoverFontSize: container.dataset.hoverFontSize || "13",
    };

    if (!treeId || !appUrl) {
      container.innerHTML = '<p style="color:red">Keuzehulp niet geconfigureerd.</p>';
      return;
    }

    // Simple session ID for this visit
    const sessionId = Math.random().toString(36).slice(2);

    fetch(`${appUrl}/api/public/trees/${treeId}?shop=${shop}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.error) { container.innerHTML = "<p>Keuzehulp kon niet worden geladen.</p>"; return; }
        renderTree(container, data.tree, lang, config, appUrl, shop, treeId);
      })
      .catch(() => { container.innerHTML = "<p>Keuzehulp kon niet worden geladen.</p>"; });
  }

  function renderTree(container, tree, lang, config, appUrl, shop, treeId) {
    const nodes = tree.nodes;
    const edges = tree.edges;

    const adjacency = {};
    edges.forEach((edge) => {
      if (!adjacency[edge.source]) adjacency[edge.source] = [];
      adjacency[edge.source].push(edge.target);
    });

    const sessionId = Math.random().toString(36).slice(2);

    function track(eventType, productId, productHandle) {
      fetch(`${appUrl}/api/public/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shop, treeId, eventType, productId, productHandle, sessionId }),
      }).catch(() => {});
    }

    const startNode = nodes.find((n) => n.data.isStart || n.id === "start") || nodes.find((n) => n.type === "question");
    if (!startNode) { container.innerHTML = "<p>Geen startpunt gevonden.</p>"; return; }

    let history = [];
    let currentNodeId = startNode.id;

    function getNode(id) { return nodes.find((n) => n.id === id); }
    function getChildren(nodeId) { return (adjacency[nodeId] || []).map(getNode).filter(Boolean); }
    function label(data) {
      // Support both new format (label_nl) and old format (labelNl)
      // Fall back to NL if translation is missing or still default "New answer"
      function isDefault(v) { return !v || v === "New answer" || v === "Nieuw antwoord"; }
      const nl = data.label_nl || data.labelNl || "";
      const en = data.label_en || data.labelEn || "";
      const de = data.label_de || "";
      const fr = data.label_fr || "";
      const es = data.label_es || "";
      const it = data.label_it || "";
      if (lang === "en") return !isDefault(en) ? en : nl;
      if (lang === "de") return !isDefault(de) ? de : nl;
      if (lang === "fr") return !isDefault(fr) ? fr : nl;
      if (lang === "es") return !isDefault(es) ? es : nl;
      if (lang === "it") return !isDefault(it) ? it : nl;
      return nl || en;
    }

    function getProductUrl(data) {
      if (data.variantId) {
        const variantNumericId = data.variantId.replace("gid://shopify/ProductVariant/", "");
        return `/products/${data.productHandle}?variant=${variantNumericId}&ref=keuzehulp&kh_tree=${treeId}&kh_session=${sessionId}`;
      }
      return `/products/${data.productHandle}?ref=keuzehulp&kh_tree=${treeId}&kh_session=${sessionId}`;
    }

    function render() {
      const node = getNode(currentNodeId);
      if (!node) return;

      container.innerHTML = "";

      const wrapper = document.createElement("div");
      wrapper.className = "keuzehulp-widget";
      wrapper.style.fontFamily = config.fontFamily;

      const depth = history.length;
      const progress = Math.min((depth / 8) * 100, 95);

      wrapper.innerHTML = `<div class="keuzehulp-progress-bar"><div class="keuzehulp-progress-fill" style="width:${progress}%"></div></div>`;

      // If current node is an answer with product children, treat as result screen
      const nodeChildren = getChildren(node.id);
      const nodeProductChildren = nodeChildren.filter(c => c.type === "product");
      const nodeAnswerChildren = nodeChildren.filter(c => c.type !== "product");
      const isResultScreen = node.type === "answer" && nodeProductChildren.length > 0;

      if (isResultScreen) {
        // Track that a result was shown
        track("result_shown", null, null);
        const isOddProducts = nodeProductChildren.length % 2 !== 0 && nodeProductChildren.length > 1;
        const productsHtml = nodeProductChildren.map((p, i) => {
          const imgHtml = p.data.productImage
            ? `<img src="${p.data.productImage}" alt="${p.data.productTitle}" class="keuzehulp-product-img">`
            : "";
          const desc = lang === "en"
            ? p.data.description_en || p.data.descriptionEn || ""
            : p.data.description_nl || p.data.descriptionNl || "";
          const variantBadge = p.data.variantTitle
            ? `<p class="keuzehulp-variant-badge">${p.data.variantTitle}</p>` : "";
          const productUrl = getProductUrl(p.data);
          const isLast = i === nodeProductChildren.length - 1;
          const extraClass = isOddProducts && isLast ? ' keuzehulp-product-card--last-odd' : '';
          return `
            <div class="keuzehulp-product-card${extraClass}">
              ${imgHtml}
              <h3 class="keuzehulp-product-title">${p.data.productTitle}</h3>
              ${variantBadge}
              ${desc ? `<p class="keuzehulp-product-desc">${desc}</p>` : ""}
              <p class="keuzehulp-product-price">€${p.data.productPrice}</p>
              <a href="${productUrl}" class="keuzehulp-cta-btn" style="background:${config.ctaColor};color:${config.ctaTextColor}" data-product-handle="${p.data.productHandle}" data-product-id="${p.data.productId || ''}">
                ${config.ctaText}
              </a>
            </div>`;
        }).join("");

        const extraButtonsHtml = nodeAnswerChildren.map(child => {
          if (child.data.imageUrl) {
            const hoverDesc = lang === "en"
              ? child.data.hoverDescription_en || child.data.hoverDescriptionEn || ""
              : child.data.hoverDescription_nl || child.data.hoverDescriptionNl || "";
            return `<button class="keuzehulp-answer-card keuzehulp-extra-option" data-target="${child.id}" style="border-color:${config.answerBorderColor}">
              <div class="keuzehulp-answer-img-wrapper" style="aspect-ratio:${config.imageRatio};">
                <img src="${child.data.imageUrl}" alt="${label(child.data)}" style="width:100%;height:100%;object-fit:cover;display:block">
                ${hoverDesc ? `<div class="keuzehulp-answer-overlay"><span class="keuzehulp-answer-overlay-text" style="font-size:${config.hoverFontSize}px">${hoverDesc}</span></div>` : ""}
              </div>
              <span class="keuzehulp-answer-card-label" style="color:${config.answerTextColor};font-size:${config.answerFontSize}px">${label(child.data)}</span>
            </button>`;
          }
          return `<button class="keuzehulp-answer-btn keuzehulp-extra-option" data-target="${child.id}"
            style="border-color:${config.answerBorderColor};color:${config.answerTextColor}">
            ${label(child.data)}
          </button>`;
        }).join("");

        wrapper.innerHTML += `
          <div class="keuzehulp-result">
            <div class="keuzehulp-result-label" style="color:${config.resultLabelColor}">${config.resultLabelText}</div>
            <div class="keuzehulp-products-grid ${nodeProductChildren.length === 1 ? 'keuzehulp-products-single' : ''}">
              ${productsHtml}
            </div>
            ${extraButtonsHtml ? `<div class="keuzehulp-extra-options">${extraButtonsHtml}</div>` : ""}
          </div>`;

      } else if (node.type === "question") {
        const children = getChildren(node.id);
        const hasImages = children.some((c) => c.data.imageUrl);

        let answersHtml = "";
        if (hasImages) {
          const isOdd = children.length % 2 !== 0;
        answersHtml = `<div class="keuzehulp-answers-grid">
            ${children.map((child, i) => {
              const hoverDesc = lang === "en"
                ? child.data.hoverDescription_en || child.data.hoverDescription || ""
                : child.data.hoverDescription_nl || child.data.hoverDescription || "";
              const hoverOverlay = child.data.imageUrl && hoverDesc
                ? `<div class="keuzehulp-hover-overlay"><span class="keuzehulp-hover-text">${hoverDesc}</span></div>`
                : "";
              return `
              <button class="keuzehulp-answer-card${isOdd && i === children.length - 1 ? ' keuzehulp-answer-card--last-odd' : ''}" data-target="${child.id}" style="border-color:${config.answerBorderColor}">
                ${child.data.imageUrl ? (() => {
                const hd = lang === "en"
                  ? child.data.hoverDescription_en || child.data.hoverDescriptionEn || ""
                  : child.data.hoverDescription_nl || child.data.hoverDescriptionNl || "";
                return `<div class="keuzehulp-answer-img-wrapper" style="aspect-ratio:${config.imageRatio};width:100%;position:relative;">
                  <img src="${child.data.imageUrl}" alt="${label(child.data)}" style="width:100%;height:100%;object-fit:cover;display:block">
                  ${hd ? `<div class="keuzehulp-answer-overlay"><span class="keuzehulp-answer-overlay-text" style="font-size:${config.hoverFontSize}px">${hd}</span></div>` : ""}
                </div>`;
              })() : ""}
                <span class="keuzehulp-answer-card-label" style="color:${config.answerTextColor};font-size:${config.answerFontSize}px">${label(child.data)}</span>
              </button>`;
            }).join("")}
          </div>`;
        } else {
          answersHtml = `<div class="keuzehulp-answers">
            ${children.map((child) => `
              <button class="keuzehulp-answer-btn" data-target="${child.id}" style="border-color:${config.answerBorderColor};color:${config.answerTextColor};font-size:${config.answerFontSize}px">${label(child.data)}</button>
            `).join("")}
          </div>`;
        }

        wrapper.innerHTML += `
          <div class="keuzehulp-question">
            <h3 class="keuzehulp-question-text">${label(node.data)}</h3>
            ${answersHtml}
          </div>`;

      } else if (node.type === "product") {
        // Find all product siblings by searching all nodes that point to a product
        // Walk up history to find the nearest non-product ancestor
        let sourceId = null;
        for (let i = history.length - 1; i >= 0; i--) {
          const ancestor = getNode(history[i]);
          if (ancestor && ancestor.type !== "product") {
            sourceId = history[i];
            break;
          }
        }
        const allProducts = sourceId
          ? getChildren(sourceId).filter(n => n.type === "product")
          : [node];
        const finalProducts = allProducts.length > 0 ? allProducts : [node];

        const productsHtml = finalProducts.map(p => {
          const imgHtml = p.data.productImage
            ? `<img src="${p.data.productImage}" alt="${p.data.productTitle}" class="keuzehulp-product-img">`
            : "";
          const desc = lang === "en"
            ? p.data.description_en || p.data.descriptionEn || ""
            : p.data.description_nl || p.data.descriptionNl || "";
          const variantBadge = p.data.variantTitle
            ? `<p class="keuzehulp-variant-badge">${p.data.variantTitle}</p>` : "";
          const productUrl = getProductUrl(p.data);
          return `
            <div class="keuzehulp-product-card">
              ${imgHtml}
              <h3 class="keuzehulp-product-title">${p.data.productTitle}</h3>
              ${variantBadge}
              ${desc ? `<p class="keuzehulp-product-desc">${desc}</p>` : ""}
              <p class="keuzehulp-product-price">€${p.data.productPrice}</p>
              <a href="${productUrl}" class="keuzehulp-cta-btn" style="background:${config.ctaColor};color:${config.ctaTextColor}" data-product-handle="${p.data.productHandle}" data-product-id="${p.data.productId || ''}">
                ${config.ctaText}
              </a>
            </div>`;
        }).join("");

        wrapper.innerHTML += `
          <div class="keuzehulp-result">
            <div class="keuzehulp-result-label" style="color:${config.resultLabelColor}">${config.resultLabelText}</div>
            <div class="keuzehulp-products-grid ${allProducts.length === 1 ? 'keuzehulp-products-single' : ''}">
              ${productsHtml}
            </div>
          </div>`;

      } else if (node.type === "noResult") {
        wrapper.innerHTML += `
          <div class="keuzehulp-no-result">
            <div class="keuzehulp-no-result-icon">😕</div>
            <p>${label(node.data)}</p>
          </div>`;
      }

      const isEndScreen = node.type === "product" || node.type === "noResult" || isResultScreen;

      if (history.length > 0 || (isEndScreen && config.extraLinkUrl)) {
        const navRow = document.createElement("div");
        navRow.style.cssText = "display:flex;justify-content:space-between;align-items:center;margin-top:16px;";

        if (history.length > 0) {
          const backBtn = document.createElement("button");
          backBtn.className = "keuzehulp-back-btn";
          backBtn.style.margin = "0";
          backBtn.textContent = lang === "en" ? "← Back" : "← Terug";
          backBtn.addEventListener("click", () => { currentNodeId = history.pop(); render(); });
          navRow.appendChild(backBtn);
        } else {
          navRow.appendChild(document.createElement("span"));
        }

        if (isEndScreen && config.extraLinkUrl) {
          const extraLink = document.createElement("a");
          extraLink.href = config.extraLinkUrl;
          extraLink.textContent = config.extraLinkText;
          extraLink.style.cssText = `color:${config.extraLinkColor};font-size:14px;text-decoration:none;font-family:inherit;`;
          extraLink.onmouseover = () => extraLink.style.textDecoration = "underline";
          extraLink.onmouseout = () => extraLink.style.textDecoration = "none";
          navRow.appendChild(extraLink);
        }

        wrapper.appendChild(navRow);
      }

      if (isEndScreen) {
        const restartBtn = document.createElement("button");
        restartBtn.className = "keuzehulp-restart-btn";
        restartBtn.textContent = lang === "en" ? "Start over" : "Opnieuw beginnen";
        restartBtn.addEventListener("click", () => { history = []; currentNodeId = startNode.id; render(); });
        wrapper.appendChild(restartBtn);
      }

      container.appendChild(wrapper);

      // Track product clicks
      wrapper.querySelectorAll(".keuzehulp-cta-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
          const handle = btn.dataset.productHandle || "";
          const id = btn.dataset.productId || "";
          track("product_clicked", id, handle);
        });
      });

      wrapper.querySelectorAll(".keuzehulp-answer-btn, .keuzehulp-answer-card").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          const targetId = e.currentTarget.dataset.target;
          const targetNode = getNode(targetId);
          if (!targetNode) return;
          history.push(currentNodeId);

          // If clicked node is an answer, check its children
          if (targetNode.type === "answer") {
            const children = getChildren(targetId);
            const productChildren = children.filter(c => c.type === "product");
            if (productChildren.length > 0) {
              // Has products — show result screen with this answer as source
              currentNodeId = targetId; // stay on answer node, render will show products
            } else if (children.length > 0) {
              currentNodeId = children[0].id;
            } else {
              currentNodeId = targetId;
            }
          } else {
            currentNodeId = targetId;
          }
          render();
        });
      });
    }

    render();
  }

  document.querySelectorAll(".keuzehulp-container").forEach(initKeuzehulp);
})();
